import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  controls: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  heading: {
    margin: 0,
    lineHeight: '24px',
    color: theme.colorPalette.green_100
  },
  radio: {
    width: '100%'
  },
  // The theme gives every FormControl a min height and bottom margin built for form grids.
  select: {
    minHeight: 0,
    marginBottom: 0
  },
  radioLabel: {
    fontSize: 14,
    color: theme.colorPalette.green_100
  },
  optionLabel: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(2)
  },
  hint: {
    fontSize: 12,
    lineHeight: '16px',
    fontStyle: 'italic',
    color: theme.colorPalette.green_75
  },
  custom: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4)
  },
  closePayments: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.beige_40
  },
  alertIcon: {
    width: 24,
    height: 24
  },
  question: {
    margin: theme.spacing(2, 0, 0),
    lineHeight: '20px',
    color: theme.colorPalette.green_100,
    '& strong': {
      fontWeight: 600
    }
  },
  error: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: 0,
    color: theme.colorPalette.red_50
  },
  errorIcon: {
    width: 16,
    height: 16
  },
  divider: {
    margin: theme.spacing(2, 0, 0),
    '&::before, &::after': {
      backgroundColor: theme.colorPalette.green_75,
      opacity: 0.2
    }
  },
  termTotalNote: {
    padding: 0
  }
}));
